module.exports = __webpack_public_path__ + "img/luohe-131a05.png";